import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getNewsList, getNewsCategory as _getNewsCategory, updateNews, updateCategory, deleteCategory as _deleteCategory } from '@/services/news';
export default {
  i18n: require('./i18n-news'),
  data: function data() {
    return {
      advanced: false,
      formData: {
        title: undefined,
        categoryIds: [],
        publishStatus: undefined,
        orderType: 2,
        orderWay: 2,
        page: 1,
        size: 20
      },
      isTableLoading: false,
      newsList: [],
      newsListTotal: 0,
      confirmLoading: false,
      columns: [{
        title: this.$t('newsList.title'),
        dataIndex: 'title',
        key: 'title',
        width: '32%',
        ellipsis: true,
        scopedSlots: {
          customRender: 'newsTitle'
        }
      }, {
        title: this.$t('newsList.category'),
        dataIndex: 'categoryList',
        key: 'categoryList',
        width: '18%',
        ellipsis: true,
        scopedSlots: {
          customRender: 'categoryList'
        }
      }, {
        title: this.$t('newsList.status'),
        dataIndex: 'publishStatus',
        key: 'publishStatus',
        width: '8%',
        scopedSlots: {
          customRender: 'newsStatus'
        }
      }, {
        title: this.$t('newsList.publishTime'),
        dataIndex: 'publishTime',
        key: 'publishTime',
        width: '15%',
        sorter: true
      }, {
        title: this.$t('newsList.lastEditTime'),
        dataIndex: 'lastUpdateTime',
        key: 'lastUpdateTime',
        width: '15%',
        sorter: true,
        defaultSortOrder: 'descend'
      }, {
        title: this.$t('publicuse.action'),
        dataIndex: 'action',
        key: 'action',
        scopedSlots: {
          customRender: 'action'
        },
        width: '12%'
      }],
      categoryList: [],
      categoryModalVisible: false,
      categoryTableLoading: false,
      categoryTableColumns: [{
        title: this.$t('newsDetail.categoryName'),
        dataIndex: 'categoryName',
        key: 'categoryName',
        width: '40%',
        ellipsis: true,
        scopedSlots: {
          customRender: 'categoryName'
        }
      }, {
        title: this.$t('newsDetail.newsNum'),
        dataIndex: 'newsNum',
        key: 'newsNum',
        width: '30%',
        ellipsis: true
      }, {
        title: this.$t('newsList.action'),
        dataIndex: 'action',
        key: 'action',
        width: '30%',
        scopedSlots: {
          customRender: 'action'
        }
      }],
      categoryForm: [],
      categoryItemRules: {
        categoryName: [{
          required: true,
          message: this.$t('newsDetail.categoryNameError'),
          trigger: 'blur'
        }]
      },
      tempCategoryId: -1
    };
  },
  created: function created() {
    this.getNewsCategory();
    this.getData();
  },
  methods: {
    getNewsCategory: function getNewsCategory() {
      var _this = this;
      return new Promise(function (resolve, reject) {
        _getNewsCategory().then(function (res) {
          if (res.data.code == 200) {
            var tempCategoryList = res.data.data.list;
            _this.categoryForm = [];
            tempCategoryList.forEach(function (item) {
              item.editStatus = false;
              _this.categoryForm.push({
                categoryName: item.categoryName
              });
            });
            _this.categoryList = tempCategoryList;
            resolve();
          }
        });
      });
    },
    getData: function getData() {
      var _this2 = this;
      var params = _.cloneDeep(this.formData);
      params.categoryIds = params.categoryIds.length ? params.categoryIds.join(',') : undefined;
      this.isTableLoading = true;
      getNewsList(params).then(function (res) {
        if (res.data.code == 200) {
          var result = res.data.data;
          result.list.forEach(function (item) {
            item.title = _.unescape(item.title);
          });
          _this2.newsList = result.list;
          _this2.newsListTotal = result.total;
        }
      }).finally(function () {
        _this2.isTableLoading = false;
      });
    },
    formSubmit: function formSubmit() {
      this.formData.page = 1;
      this.getData();
    },
    showCategoryModal: function showCategoryModal() {
      var _this3 = this;
      this.getNewsCategory().then(function () {
        _this3.categoryModalVisible = true;
      });
    },
    createCategory: function createCategory() {
      this.categoryList.push({
        categoryId: this.tempCategoryId,
        categoryName: '',
        newsNum: 0,
        editStatus: true
      });
      this.categoryForm.push({
        categoryName: ''
      });
      this.tempCategoryId -= 1;
    },
    saveCategory: function saveCategory(record, index) {
      var _this4 = this;
      this.$refs['categoryItemForm' + index].validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(valid) {
          var res;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (!valid) {
                  _context.n = 8;
                  break;
                }
                if (!record.updateCategoryLoading) {
                  _context.n = 1;
                  break;
                }
                return _context.a(2);
              case 1:
                record.updateCategoryLoading = true;
                _context.p = 2;
                if (!(record.categoryId < 0)) {
                  _context.n = 4;
                  break;
                }
                _context.n = 3;
                return updateCategory({
                  categoryName: _this4.categoryForm[index].categoryName
                });
              case 3:
                res = _context.v;
                _context.n = 6;
                break;
              case 4:
                _context.n = 5;
                return updateCategory({
                  categoryId: record.categoryId,
                  categoryName: _this4.categoryForm[index].categoryName
                });
              case 5:
                res = _context.v;
              case 6:
                if (res.data.code == 200) {
                  res.data.data && (record.categoryId = res.data.data.categoryId);
                  record.categoryName = _this4.categoryForm[index].categoryName;
                  record.editStatus = false;
                  _this4.formData.categoryIds = [];
                }
              case 7:
                _context.p = 7;
                record.updateCategoryLoading = false;
                return _context.f(7);
              case 8:
                return _context.a(2);
            }
          }, _callee, null, [[2,, 7, 8]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    cancelCategory: function cancelCategory(record, index) {
      if (record.categoryId < 0) {
        this.categoryList.splice(index, 1);
        this.categoryForm.splice(index, 1);
      } else {
        record.editStatus = false;
        this.categoryForm[index].categoryName = record.categoryName;
      }
    },
    deleteCategory: function deleteCategory(record, index) {
      var _this5 = this;
      _deleteCategory({
        categoryId: record.categoryId
      }).then(function (res) {
        if (res.data.code == 200) {
          _this5.categoryList.splice(index, 1);
          _this5.categoryForm.splice(index, 1);
        }
      });
    },
    cancelCategoryModal: function cancelCategoryModal() {
      this.categoryModalVisible = false;
      this.categoryList.forEach(function (item, index) {
        item.editStatus = false;
      });
    },
    tableChange: function tableChange(pagination, filters, sorter, _ref2) {
      var currentDataSource = _ref2.currentDataSource;
      if (sorter.order) {
        var orderType = {
          lastUpdateTime: 2,
          publishTime: 1
        };
        this.formData.orderType = orderType[sorter.columnKey];
        this.formData.orderWay = sorter.order == 'ascend' ? 1 : 2;
      } else {
        this.formData.orderType = undefined;
        this.formData.orderWay = undefined;
      }
      this.formData.page = pagination.current;
      this.formData.size = pagination.pageSize;
      this.getData();
    },
    createNews: function createNews() {
      this.$router.push({
        name: 'NewsAdd'
      });
    },
    editNews: function editNews(id) {
      var route = this.$router.resolve({
        name: 'NewsEdit',
        query: {
          id: id,
          page: this.formData.page,
          size: this.formData.size
        }
      });
      window.open(route.href, '_blank');
    },
    topNews: function topNews(record) {
      var _this6 = this;
      if (record.topNewsLoading) return;
      record.topNewsLoading = true;
      updateNews({
        scene: 2,
        id: record.id,
        newStatus: record.topFlag ? 0 : 1
      }).then(function (res) {
        if (res.data.code == 200) {
          _this6.getData();
        }
      }).finally(function () {
        record.topNewsLoading = false;
      });
    },
    publishNews: function publishNews(record) {
      var _this7 = this;
      if (record.publishNewsLoading) return;
      record.publishNewsLoading = true;
      updateNews({
        scene: 1,
        id: record.id,
        newStatus: record.publishStatus ? 0 : 1
      }).then(function (res) {
        if (res.data.code == 200) {
          _this7.getData();
        }
      }).finally(function () {
        record.publishNewsLoading = false;
      });
    },
    deleteNews: function deleteNews(id, index, record) {
      var _this8 = this;
      if (record.deleteNewsLoading) return;
      record.deleteNewsLoading = true;
      updateNews({
        scene: 3,
        id: id,
        newStatus: 1
      }).then(function (res) {
        if (res.data.code == 200) {
          _this8.newsList.splice(index, 1);
        }
      }).finally(function () {
        record.deleteNewsLoading = false;
      });
    }
  }
};